module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f4578dc60a4dcd863f939780adcc12eb.png";